import { NotificationService } from 'services/notification/notification.service';
import { call, put, takeEvery } from 'typed-redux-saga';

import { homeAction } from '../actions';
import { homeConstant } from '../actionTypes';

const getListNotificationData = function* () {
  const data = yield* call(() => NotificationService.getNotifications());

  if (data?.data.length >= 0) {
    yield* put(homeAction.updateStateNotification(data));
  }
};

const putMarkAsReadNotificationData = function* () {
  yield* call(() => {
    return NotificationService.markAsReadNotification();
  });
  yield* put(homeAction.updateStateMarkAsReadNotification());
};

export const watchPutMarkAsReadNotification = function* () {
  yield* takeEvery(homeConstant.MARK_AS_READ_NOTIFICATION, putMarkAsReadNotificationData);
};

export const watchGetListNotification = function* () {
  yield* takeEvery(homeConstant.GET_NOTIFICATION, getListNotificationData);
};
